import * as Schema from "effect/Schema";

import { TrimmedNonEmptyString } from "./baseSchemas";

/**
 * One entry returned by `GET /api/cloud/available-folders` — a candidate
 * subdirectory of the managed runtime's `cloudProjectsRoot` (typically `/projects`)
 * that the SPA can offer in the cloud-mode "Register existing folder" picker.
 */
export const CloudAvailableFolder = Schema.Struct({
  name: TrimmedNonEmptyString,
  fullPath: TrimmedNonEmptyString,
  isGitRepo: Schema.Boolean,
  alreadyRegistered: Schema.Boolean,
});
export type CloudAvailableFolder = typeof CloudAvailableFolder.Type;

export const CloudAvailableFoldersResponse = Schema.Struct({
  root: TrimmedNonEmptyString,
  folders: Schema.Array(CloudAvailableFolder),
});
export type CloudAvailableFoldersResponse = typeof CloudAvailableFoldersResponse.Type;
